import axios from "axios";
import {endpoint} from "../../config/app.config";
import { clearCookie, getCookie, setParentDomainCookie } from "../../utils/cookies";

const { token, reset, sub, user } = getCookie()

export const getRoles = () => {
  clearCookie()
  return axios
    .get(`${endpoint}/api/user/degree`, { withCredentials: false })
    .then((response) => {
      setParentDomainCookie(token, reset, sub, user)
      return response.data;
    })
    .catch((err) => {
      throw err;
    })
}

export const setRole = (payload) => {
  clearCookie()
  return axios
    .post(`${endpoint}/api/user`, payload, { withCredentials: false })
    .then((response) => {
      setParentDomainCookie(token, reset, sub, user)
      return response.data;
    })
    .catch((err) => {
      throw err;
    })
}
